import { render, staticRenderFns } from "./component.vue?vue&type=template&id=12cbfa60&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=12cbfa60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cbfa60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12cbfa60')) {
      api.createRecord('12cbfa60', component.options)
    } else {
      api.reload('12cbfa60', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=12cbfa60&scoped=true&", function () {
      api.rerender('12cbfa60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/product/component.vue"
export default component.exports